// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4ef333e2","977":"042c8deb"}[chunkId] + ".chunk.js";
};